import { render, staticRenderFns } from "./captoresDigitales.vue?vue&type=template&id=2e8cd003&scoped=true&"
import script from "./captoresDigitales.vue?vue&type=script&lang=js&"
export * from "./captoresDigitales.vue?vue&type=script&lang=js&"
import style0 from "./captoresDigitales.vue?vue&type=style&index=0&id=2e8cd003&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e8cd003",
  null
  
)

export default component.exports